import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useUsers } from "../hooks/useUsers";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../components/ui/DeleteModal";
import { toast } from "react-toastify";
import PublicLayout from "../components/layout/PublicLayout";

const DeleteAccount = () => {
  const { user, logout } = useAuth();
  const { deleteUser } = useUsers();
  const navigate = useNavigate();

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const mutation = useMutation({
    mutationFn: async () => {
      if (!user || !user._id) {
        throw new Error("User not found");
      }
      return await deleteUser(user._id);
    },
    onSuccess: () => {
      toast.success("Account deleted successfully");
      logout();
      navigate("/login");
    },
    onError: (error) => {
      toast.error(error.message || "Failed to delete account");
    },
  });

  const openModal = () => setDeleteModalOpen(true);
  const closeModal = () => setDeleteModalOpen(false);

  const handleDelete = () => {
    // mutation.mutate();
    toast("Account deletion is disabled for demo purposes", {
      type: "info",
      autoClose: 3000,
    });
    closeModal();
  };

  return (
    <PublicLayout>
      <div className="max-w-md mx-auto mt-20 p-6 bg-white rounded shadow">
        <h1 className="text-2xl font-bold mb-4">Delete Account</h1>
        <p className="mb-6 text-gray-700">
          Deleting your account is permanent and cannot be undone. All your data
          will be lost. Please confirm if you want to proceed.
        </p>
        <button
          onClick={openModal}
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 focus:outline-none"
          disabled={mutation.isLoading}
        >
          {mutation.isLoading ? "Deleting..." : "Delete My Account"}
        </button>

        <DeleteModal
          isOpen={deleteModalOpen}
          onClose={closeModal}
          onDelete={handleDelete}
          title="Delete Account"
          description="Are you sure you want to delete your account? This action cannot be undone."
        />
      </div>
    </PublicLayout>
  );
};

export default DeleteAccount;
